module.exports = __webpack_public_path__ + "img/bi-user-group.42903e54.png";